import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { MaterialIcons } from '@expo/vector-icons';
import { useTheme } from 'react-native-paper';

// Import screen components
import DashboardScreen from '../screens/DashboardScreen';
import MapScreen from '../screens/MapScreen';
import TripsScreen from '../screens/TripsScreen';
import BasicProfileScreen from '../screens/BasicProfileScreen';
import WeatherDetailsScreen from '../screens/WeatherDetailsScreen';
import TripDetailsScreen from '../screens/TripDetailsScreen';
import CatchReportScreen from '../screens/CatchReportScreen';
import CatchHistoryScreen from '../screens/CatchHistoryScreen';
import CatchDetailScreen from '../screens/CatchDetailScreen';
import FishingSpotScreen from '../screens/FishingSpotScreen';
import SettingsScreen from '../screens/SettingsScreen';
import LocationPickerScreen from '../screens/LocationPickerScreen';
import ReportDetailScreen from '../screens/ReportDetailScreen';
import WaypointsScreen from '../screens/WaypointsScreen';
import SubscriptionScreen from '../screens/SubscriptionScreen';

// Import navigation types
import { RootStackParamList, TabParamList } from '../types';

// Create navigators - using JS stack for cross-platform compatibility
const Stack = createStackNavigator<RootStackParamList>();
const Tab = createBottomTabNavigator<TabParamList>();

// Tab Navigator Component
function TabNavigator() {
  const theme = useTheme();

  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        tabBarIcon: ({ focused, color, size }) => {
          let iconName: keyof typeof MaterialIcons.glyphMap;

          switch (route.name) {
            case 'Dashboard':
              iconName = 'dashboard';
              break;
            case 'Map':
              iconName = 'map';
              break;
            case 'Trips':
              iconName = 'auto-awesome';
              break;
            case 'Profile':
              iconName = 'person';
              break;
            default:
              iconName = 'circle';
          }

          return <MaterialIcons name={iconName} size={size} color={color} />;
        },
        tabBarActiveTintColor: theme.colors.primary,
        tabBarInactiveTintColor: 'gray',
        headerStyle: {
          backgroundColor: theme.colors.primary,
        },
        headerTintColor: theme.colors.onPrimary,
      })}
    >
      <Tab.Screen name="Dashboard" component={DashboardScreen} options={{ title: 'Ocean Insight Pro' }} />
      <Tab.Screen name="Map" component={MapScreen} options={{ title: 'Ocean Map' }} />
      <Tab.Screen name="Trips" component={TripsScreen} options={{ title: 'AI Assistant' }} />
      <Tab.Screen name="Profile" component={BasicProfileScreen} options={{ title: 'Profile' }} />
    </Tab.Navigator>
  );
}

// Main App Navigator
export default function SimpleAppNavigator() {
  const theme = useTheme();

  return (
    <Stack.Navigator
      screenOptions={{
        headerStyle: {
          backgroundColor: theme.colors.primary,
        },
        headerTintColor: theme.colors.onPrimary,
        headerTitleStyle: {
          fontWeight: 'bold',
        },
      }}
    >
      <Stack.Screen name="Home" component={TabNavigator} options={{ headerShown: false }} />
      <Stack.Screen name="WeatherDetails" component={WeatherDetailsScreen} options={{ title: 'Weather Details' }} />
      <Stack.Screen name="TripDetails" component={TripDetailsScreen} options={{ title: 'Trip Details' }} />
      <Stack.Screen name="CatchReport" component={CatchReportScreen} options={{ title: 'Log Catch' }} />
      <Stack.Screen name="CatchHistory" component={CatchHistoryScreen} options={{ title: 'Catch History' }} />
      <Stack.Screen name="CatchDetail" component={CatchDetailScreen} options={{ title: 'Catch Details' }} />
      <Stack.Screen name="FishingSpot" component={FishingSpotScreen} options={{ title: 'Fishing Spot' }} />
      <Stack.Screen name="Settings" component={SettingsScreen} options={{ title: 'Settings' }} />
      <Stack.Screen name="LocationPicker" component={LocationPickerScreen} options={{ title: 'Check Location' }} />
      <Stack.Screen name="ReportDetail" component={ReportDetailScreen} options={{ title: 'Fishing Report' }} />
      <Stack.Screen name="Waypoints" component={WaypointsScreen} options={{ title: 'My Waypoints' }} />
      <Stack.Screen name="Subscription" component={SubscriptionScreen} options={{ title: 'Subscription' }} />
    </Stack.Navigator>
  );
}